import { Component, Input, ViewChild, ViewChildren, QueryList, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Job, WidgetInput } from '../../Models/job-like-job.model';
import { JobToJobListService } from '../../services/ailike-jobs.service';
import { HtmlDecodePipe,SafeEmbedHtmlPipe} from '../../pipes/Angular-commonUtil.pipe';
import { TruncatePipe } from '../../pipes/truncate.pipe';


@Component({
  selector: 'job-job-list',
  standalone: true,
  imports: [CommonModule,HtmlDecodePipe, SafeEmbedHtmlPipe, TruncatePipe],
  templateUrl: './job-to-joblist-widget.component.html',
  styleUrls: ['./job-to-joblist-widget.component.scss']
})

export class JobToJobListComponent implements AfterViewInit {
  translateStrings: any = {};
  TgSettings: any = {};
  pageType: string = '';

  @Input() set widgetData(data: WidgetInput) {
    if (data) {
      this.translateStrings = data.TranslateStrings || {};
      this.TgSettings = data.tgsetting || {};
      this.pageType = data.pagetype.toLowerCase();
      this.loadJobs(data);
    }
  }

  @Input() job: any;
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('similarJobcardElement') card!: ElementRef<HTMLDivElement>;
  @ViewChildren('similarJobcardElement') cards!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('similarJobcardElement') cardElements!: QueryList<ElementRef>;
  parmJob: any;


  jobs: any[] = [];
  expandedJobIndex: number | null = null;
  isCarouselFocused = false;
  showLeftBtn = false;
  showRightBtn = true;
  totalCards = 0;
  visibleCards = 0;

  enableSocialReferral = true;
  constructor(private jobService: JobToJobListService) { }


  ngAfterViewInit(): void {
    this.cardElements.changes.subscribe(() => {
      setTimeout(() => {
        this.updateScrollButtons();
      }, 0);
    });
    setTimeout(() => {
      this.updateScrollButtons();
    }, 0);
    let scrollTimeout: any;
    this.scrollContainer?.nativeElement.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateScrollButtons(), 100);
    });
  }
  onScroll(): void {
    this.updateScrollButtons();
  }


  loadJobs(data: WidgetInput): void {
    if (data) {
      const appScope = (window as any).appScope;
      this.jobs = [];
      this.translateStrings = data.TranslateStrings || {};
      this.TgSettings = data.tgsetting || {};
      const requestPayload = {
        partnerId: +data.partnerId,
        siteId: +data.siteId,
        ReqId: +data.ReqId,
        sessionId: data.sessionId,
        turnOffHttps: false
      };
      this.jobService.fetchJobs(requestPayload).subscribe({
        next: (res: Job[]) => {
          console.log(res);
          this.jobs = res || [];
          if (this.jobs.length > 0) {
            
            appScope.viewSimilarJobsBtn = true;
          }
        },
        error: (err: any) => console.error('Failed to load jobs', err)
      });
    }
  }
  handleClick($event: any, job: any, pagetype: 'apply'): void {
    console.log('Button clicked!');
    this.expandedJobIndex = null;
    //alert('Button was clicked!');
    const appScope = (window as any).appScope;
    appScope.ApplyFrmSimilarJobswidget($event, job, "apply");
  }
  extractJobFieldsFromQuestions(questions: any[]): {
    jobtitle: string;
    lastupdated: string;
    autoreq: string;
    jobdescription: string;
  } {
    const getValue = (name: string) =>
      questions.find(q => q.QuestionName === name)?.Value || '';

    return {
      jobtitle: getValue('jobtitle'),
      lastupdated: getValue('lastupdated'),
      autoreq: getValue('autoreq'),
      jobdescription: getValue('jobdescription')
    };
  }
  onJobTitleClickFromMouse(event: MouseEvent, job: any, jobId: string): void {
    this.onJobTitleClick(event, job, jobId);
  }
  onJobTitleClickFromKeyboard(event: Event, job: any, jobId: string): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.key === 'Enter') {
      this.onJobTitleClick(keyEvent, job, jobId);
    }
  }

  private onJobTitleClick(event: MouseEvent | KeyboardEvent, job: any, jobId: string): void {
    if (event instanceof KeyboardEvent && event.key !== 'Enter') return;
    const appScope = (window as any).appScope;
    appScope.job = job;
    appScope.jobs = this.jobs;

    if (appScope?.handlers?.jobTitle) {
      appScope.handlers.jobTitle(appScope, false, jobId);
    } else {
      console.error('jobTitle handler not found on appScope');
    }
  }

  toggleReadMore(index: number, job: any): void {
    this.expandedJobIndex = index;
    this.parmJob = job;
    setTimeout(() => {
      const modal = document.querySelector<HTMLElement>('.readmore-modal');
      const closeBtn = modal?.querySelector<HTMLElement>('.close-icon');
      const focusables = modal?.querySelectorAll<HTMLElement>('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!modal || !closeBtn || !focusables?.length) return;
      closeBtn.focus();
      const [first, last] = [focusables[0], focusables[focusables.length - 1]];
      modal.onkeydown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          setTimeout(() => {
            const active = document.activeElement;
            if (!modal.contains(active)) (e.shiftKey ? last : first).focus();
          }, 1);
        }
      };
    }, 0);
  }

  closeReadMore(): void {
    const index = this.expandedJobIndex;
    if (index === null) return;
    this.expandedJobIndex = null;
    const modal = document.querySelector('.readmore-modal') as HTMLElement;
    if (modal && (modal as any)._trapFocus) {
      modal.removeEventListener('keydown', (modal as any)._trapFocus);
      delete (modal as any)._trapFocus;
    }
    requestAnimationFrame(() => {
      setTimeout(() => {
        const cards = this.cardElements?.toArray();
        if (!cards?.length) return;
        const next = (index + 1) % cards.length;
        const nextCard = cards[next]?.nativeElement;
        if (nextCard) {
          nextCard.focus();
          nextCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 0);
    });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  showRenderedFields(questions: any[]): any[] {
    return questions?.filter(q => !!q?.ClassName);
  }
  displayRenderedFields(aoFields: any[]) {
    return HtmlDecodePipe.displayRenderedFields(aoFields);
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateScrollButtons();
  }


  checkHotJob(job: any): boolean {
    const hotJobValue = job?.Questions?.find((q: any) => q.QuestionName === 'hotjob')?.Value;
    return (hotJobValue || '').toString().toLowerCase() === 'yes';
  }

  handlers = {
    jobClick: (event: MouseEvent, job: any) => {
    }
  };

  scrollLeft(): void {
    this.scrollByVisibleCards(-1);
    setTimeout(() => this.updateScrollButtons(), 500);
  }

  scrollRight(): void {
    this.scrollByVisibleCards(1);
    setTimeout(() => this.updateScrollButtons(), 500);
  }

  updateScrollButtons(): void {
    const container = this.scrollContainer?.nativeElement;
    if (!container) {
      this.showLeftBtn = false;
      this.showRightBtn = false;
      return;
    }
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const containerWidth = container.clientWidth;
    const buffer = 1;
    const isScrollable = scrollWidth > containerWidth + buffer;
    if (!isScrollable) {
      this.showLeftBtn = false;
      this.showRightBtn = false;
      return;
    }
    this.showLeftBtn = scrollLeft > buffer;
    this.showRightBtn = (scrollLeft + containerWidth) < (scrollWidth - buffer);
  }

  scrollByVisibleCards(direction: 1 | -1): void {
    const container = this.scrollContainer?.nativeElement;
    const card = this.card?.nativeElement;
    if (!container || !card) return;

    const containerWidth = container.clientWidth;
    const cardStyle = getComputedStyle(card);
    const cardMarginRight = parseFloat(cardStyle.marginRight) || 0;
    const cardWidth = card.offsetWidth + cardMarginRight;
    let scrollStep: number;
    // Mobile: scroll by 1 card, Desktop: scroll by visible card count
    if (window.innerWidth <= 768) {
      scrollStep = cardWidth;
    } else {
      const visibleCards = Math.floor(containerWidth / cardWidth);
      scrollStep = visibleCards * cardWidth;
    }
    const newScroll = Math.max(
      0,
      Math.min(container.scrollLeft + direction * scrollStep, container.scrollWidth - containerWidth)
    );
    animateScroll(container, newScroll, 500);
  }

}
function animateScroll(element: HTMLElement, to: number, duration: number) {
  const start = element.scrollLeft;
  const change = to - start;
  const startTime = performance.now();
  const prevSnapType = element.style.scrollSnapType;
  element.style.scrollSnapType = 'none';

  function easeInOutQuad(t: number): number {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;  // 👈 Make end softer
  }

  function animate(time: number) {
    const currentTime = (time - startTime) / duration;
    const easedTime = easeInOutQuad(Math.min(currentTime, 1));
    element.scrollLeft = start + change * easedTime;
    if (currentTime < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.scrollSnapType = prevSnapType;
      element.scrollLeft = to;
    }
  }
  requestAnimationFrame(animate);
}
